import { getFromStorage, setStorageValue } from '@/helpers/helpers'

const RELOAD_COOLDOWN_MS = 5 * 60 * 1000
const RELOAD_COOLDOWN_STORAGE_KEY = 'staleClientLastReloadAt'

// Note: shared across every stale-client reload trigger (silent, forced, chunk-load-error)
// so a misfiring detector can't chain reloads into a loop — see EL-13298.
export const canReloadNow = (): boolean => {
  const lastReloadAt = getFromStorage(RELOAD_COOLDOWN_STORAGE_KEY, 0)
  return Date.now() - lastReloadAt > RELOAD_COOLDOWN_MS
}

export const markReloaded = (): void => {
  setStorageValue(RELOAD_COOLDOWN_STORAGE_KEY, Date.now())
}
